import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_useNativeButton"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { trackScreen } from '../lib/tracker';
import UserPreferencesGravatarUploader from './UserPreferencesGravatarUploader';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import AsyncUserPreferencesAvatarUploader from './AsyncUserPreferencesAvatarUploader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default class Avatar extends Component {
  constructor(props) {
    super(props);
    this.handleUploadClick = () => {
      trackScreen('avatar-upload');
      this.setState({
        open: false,
        avatarOpen: true
      });
    };
    this.handleGravatarClick = () => {
      trackScreen('avatar-gravatar');
      this.setState({
        open: false,
        gravatarOpen: true
      });
    };
    this.handleRemoveAvatarClick = () => {
      const {
        removeAvatar
      } = this.props;
      removeAvatar();
      this.setState({
        open: false
      });
    };
    this.renderButton = buttonProps => {
      const {
        avatarUrl,
        size,
        disabled
      } = this.props;
      const buttonPropsFiltered = _objectWithoutPropertiesLoose(buttonProps, _excluded);
      return /*#__PURE__*/_jsx(Clickable, Object.assign({}, buttonPropsFiltered, {
        children: /*#__PURE__*/_jsx(UIAvatar, {
          src: avatarUrl,
          isHoverlay: !disabled,
          size: size
        })
      }));
    };
    this.state = {
      open: false,
      gravatarOpen: false,
      avatarOpen: false
    };
  }
  componentDidUpdate(__prevProps, prevState) {
    const {
      open
    } = this.state;
    const {
      open: prevOpen
    } = prevState;
    if (open && !prevOpen) {
      trackScreen('avatar-menu');
    }
  }
  render() {
    const {
      disabled,
      emailHash,
      setGravatar,
      uploadAvatar
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Dropdown, {
        arrowSize: "medium",
        Button: this.renderButton,
        open: this.state.open,
        readOnly: disabled,
        placement: "bottom",
        menuWidth: 168,
        onOpenChange: () => {
          this.setState({
            open: !this.state.open
          });
        },
        popoverProps: {
          _distanceAdjustment: -30,
          onFocusLeave: () => {
            this.setState({
              open: false
            });
          },
          onMouseLeave: () => {
            this.setState({
              open: false
            });
          }
        },
        children: /*#__PURE__*/_jsxs(List, {
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: this.handleUploadClick,
            children: I18n.text('userPreferences.avatar.upload.link')
          }), /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: this.handleGravatarClick,
            children: I18n.text('userPreferences.avatar.gravatar.link')
          }), /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: this.handleRemoveAvatarClick,
            children: I18n.text('userPreferences.avatar.remove')
          })]
        })
      }), this.state.gravatarOpen && /*#__PURE__*/_jsx(UserPreferencesGravatarUploader, {
        emailHash: emailHash,
        onConfirm: () => {
          setGravatar();
          this.setState({
            gravatarOpen: false
          });
        },
        onReject: () => {
          this.setState({
            gravatarOpen: false
          });
        }
      }), this.state.avatarOpen && /*#__PURE__*/_jsx(AsyncUserPreferencesAvatarUploader, {
        uploadAvatar: uploadAvatar,
        onConfirm: () => {
          this.setState({
            avatarOpen: false
          });
        },
        onReject: () => {
          this.setState({
            avatarOpen: false
          });
        }
      })]
    });
  }
}
Avatar.propTypes = {
  avatarUrl: PropTypes.string,
  emailHash: PropTypes.string.isRequired,
  removeAvatar: PropTypes.func.isRequired,
  setGravatar: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  uploadAvatar: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};